import {
  AbsoluteContainer,
  Badge,
  Cushion,
  Grid,
  Hide,
  Rectangle,
  Space,
  Typography,
} from '@pitchero/react-ui';
import { identity, map, pickBy } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import Icon from '../icon';
import { Trans } from '../../lib/i18n';
import MapComponent from '../map';

const BREAKPOINT = 840;

const MatchLocation = ({ location, homeTeam }) => {
  if (!location) {
    return null;
  }

  const { address1, address2, address3, address4, postcode } = location;

  const addressParts = pickBy(
    {
      address1,
      address2,
      address3,
      address4,
      postcode,
    },
    identity,
  );

  const validCoords =
    typeof location.lat === 'number' &&
    typeof location.lng === 'number' &&
    !(location.lat === 0 && location.lng === 0);

  return (
    <Space bottom="large">
      <Rectangle fill="white" radius="rounded">
        <Grid
          className="ie-flex"
          alignItems="center"
          columns="minmax(200px,400px) minmax(480px, 894px)"
          responsive={[{ maxWidth: 'fullHeader', props: { display: 'block' } }]}
          style={{ overflow: 'hidden' }}
        >
          <Hide
            maxWidth={validCoords ? 0 : BREAKPOINT}
            component="div"
            style={{ position: 'relative', flex: 1 }}
          >
            {validCoords && (
              <AbsoluteContainer
                top="50%"
                left="50%"
                style={{ margin: '-56px 0px 0px -26px', zIndex: 1 }}
              >
                <Badge
                  primary={homeTeam.colours.primary}
                  secondary={homeTeam.colours.secondary}
                  size={40}
                />
              </AbsoluteContainer>
            )}

            <MapComponent
              name={location.name}
              lat={location.lat}
              lng={location.lng}
              height={309}
              width={720}
              objectFit="cover"
              objectPosition="center"
              style={{
                borderRadius: '0 4px 4px 0',
                display: 'block',
                width: '100%',
              }}
              responsive={[
                {
                  minWidth: 600,
                  width: '100%',
                  height: '100%',
                },
                {
                  maxWidth: 599,
                  height: '210px',
                  width: '100%',
                },
              ]}
            />
          </Hide>
          <Cushion all="large" component="div" style={{ gridColumnStart: 1, gridRowStart: 1 }}>
            <Space bottom="small">
              <Icon name="location" size={30} color="primary" />
            </Space>
            <Typography preset="subtitle--large" component="h3">
              {location.name}
            </Typography>
            <Typography preset="body--small" component="p">
              {map(addressParts, (part, key) => (
                <React.Fragment key={`address${key}`}>
                  {part}
                  <br />
                </React.Fragment>
              ))}
            </Typography>
            {validCoords && (
              <Typography
                preset="name"
                color="primary"
                component="a"
                href={`https://maps.google.com/maps?z=12&t=m&q=${location.lat},${location.lng}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Trans i18nKey="common:view_on_google_maps">View on Google maps</Trans>
              </Typography>
            )}
          </Cushion>
        </Grid>
      </Rectangle>
    </Space>
  );
};

MatchLocation.defaultProps = {
  location: null,
};

MatchLocation.propTypes = {
  homeTeam: PropTypes.shape({
    colours: PropTypes.shape({
      primary: PropTypes.string,
      secondary: PropTypes.string,
    }),
  }).isRequired,
  location: PropTypes.shape({
    name: PropTypes.string,
    address1: PropTypes.string,
    address2: PropTypes.string,
    address3: PropTypes.string,
    address4: PropTypes.string,
    postcode: PropTypes.string,
    lat: PropTypes.number,
    lng: PropTypes.number,
  }),
};

export default MatchLocation;
